export const Props = () => ({
  //--------------------------------------------------------------------------
  //      Где рендериться список комментариев? (В попапе или на странице)
  //--------------------------------------------------------------------------
  commentsPlace: {
    type: String,
    required: true,
    validator: (value) => {
      const allowedTypes = ['popup', 'page'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'commentsPlace' в компоненте CommentsForm может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});